export default "__VITE_PUBLIC_ASSET__97e243ef__"